import * as React from 'react';
import Svg, {Circle, Path} from 'react-native-svg';
type NotifyDealIconProps = {
  width?: number;
  height?: number;
  bgColor?: string;
  opacity?: number;
};
export default class GiftIconCP extends React.Component<NotifyDealIconProps> {
  render() {
    return (
      <Svg width={40} height={40} viewBox="0 0 40 40" fill="none">
        <Circle
          cx={20}
          cy={20}
          r={20}
          fill={this.props.bgColor ?? '#003349'}
          fillOpacity={this.props.opacity ?? 0.2}
        />
        <Path
          d="M25.556 20v6.944H14.445v-6.945M20 26.944V16.527m0 0h-3.125a1.736 1.736 0 010-3.472c2.43 0 3.125 3.472 3.125 3.472zm0 0h3.125a1.736 1.736 0 100-3.472c-2.43 0-3.125 3.472-3.125 3.472zm-6.944 0h13.889v3.472h-13.89v-3.472z"
          stroke={this.props.bgColor ?? '#003349'}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </Svg>
    );
  }
}
